<template>

  <div>

    <h2><i class="fa fa-broadcast-tower">&nbsp;</i><org-badge /> Dashboard<small v-if="!isTowerCo() && org().shortName" class="text-info pull-right hidden-sm-and-down">{{org().name}}</small></h2>

    <el-row style="padding-top: 0.5em;">

      <el-col :span="24">
        <el-tabs type="border-card">

          <el-tab-pane lazy>
            <span slot="label"><i class="fa fa-tower-cell"></i> Tower Suppliers Report</span>
            <tower-suppliers-report  />
          </el-tab-pane>

          <el-tab-pane lazy>
            <span slot="label"><i class="fa fa-sitemap"></i> Structures Report</span>
            <structure-report supplier />
          </el-tab-pane>

        </el-tabs>
      </el-col>

    </el-row>

  </div>

</template>

<script>

import StructureReport from '@/components/dashboard/sites/StructureReport'
import TowerSuppliersReport from '@/components/dashboard/sites/TowerSuppliersReport'


export default {

  components: {
    StructureReport,
    TowerSuppliersReport
  },

}
</script>
